import axios from 'axios'
import iView from 'view-design'
import store from '../store'
import { getToken } from '../libs/util'
import router from '../router'

class HttpRequest {
  constructor (baseUrl = process.env.VUE_APP_BASE_API) {
    this.baseUrl = baseUrl
    this.queue = {}
  }

  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: { Authorization: null }
    }
    if (getToken()) config.headers.Authorization = 'Bearer ' + getToken()
    return config
  }
  destroy (url) {
    delete this.queue[url]
    // if (!Object.keys(this.queue).length) iView.LoadingBar.finish()
  }
  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // if (!Object.keys(this.queue).length) iView.LoadingBar.start()
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(response => {
      const res = response.data
      if (res instanceof Blob) return response
      if (res.code !== 200 || res.code === -14) {
        if (res.code === -14) {
          store.dispatch('resetToken').then(() => {
            router.push({ name: 'login' })
          })
        } else {
          const msg = res.msg && res.msg.substr(0, 150)
          iView.Notice.error({ desc: msg || 'Error', title: '操作失败！' })
        }
        throw new Error(res.msg)
      } else {
        this.destroy(url)
        return res
      }
    }, error => {
      iView.Notice.error({ desc: error || 'Error', title: '网络异常！' })
      return Promise.reject(error)
    })
  }

  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}

const request = new HttpRequest(process.env.VUE_APP_BASE_API)
export default request
